import React, {lazy, Suspense} from "react";
import {Switch, Route, Redirect} from "react-router-dom";

const Login = lazy(() => import("./views/auth/Login"));
const Signup = lazy(() => import("./views/auth/Signup"));
//import AuthedRoute, {EditorRoute, AdminRoute, BrandRoute} from "./views/auth/AuthedRoute"
const AuthedRoute = lazy(() => import("./views/auth/AuthedRoute"));
const AdminRoute = lazy(() => import("./views/auth/AdminRoute"));
const EditorRoute = lazy(() => import("./views/auth/EditorRoute"));
const BrandRoute = lazy(() => import("./views/auth/BrandRoute"));
const Home = lazy(() => import("./views/Home"));
const Admin = lazy(() => import("./views/Admin"));
const EditorDashboard = lazy(() => import("./views/EditorDashboard"));
const MyNotesDashboard = lazy(() => import("./views/MyNotesDashboard"));
const MyVotes = lazy(() => import("./views/MyVotes"));
const ReaderDashboard = lazy(() => import("./views/ReaderDashboard"));
const About = lazy(() => import("./views/About"));
const Unsubscribe = lazy(() => import("./views/Unsubscribe"));
const NewEditor = lazy(() => import("./views/NewEditor"));
const DraftActivity = lazy(() => import("./views/DraftActivity"));
const Baa = lazy(() => import("./views/Baa"));
const BrandLogin = lazy(() => import("./views/auth/BrandLogin"));
const IceBreakerQuiz = lazy(() => import("./views/brands/IceBreakerQuiz"));
const Stats = lazy(() => import("./views/Stats"));
const NewsletterStats = lazy(() => import("./views/NewsletterStats"));
const StoryStats = lazy(() => import("./views/StoryStats"));
const Profile = lazy(() => import("./views/Profile"));
const UserOnboarding = lazy(() => import("./views/UserOnboarding"));
const Bookmarks = lazy(() => import("./views/Bookmarks"));
const NewDraft = lazy(() => import("./views/NewDraft"));
const TranslatedEditor = lazy(() => import("./views/TranslatedEditor"));
const Editor = lazy(() => import("./views/Editor"));
const SloggingReordering = lazy(() => import("./views/SloggingReordering"));
const SponsorOnboarding = lazy(() => import("./views/SponsorOnboarding"));
const SponsorAd = lazy(() => import("./views/SponsorAd"));
const SponsorDashboard = lazy(() => import("./views/SponsorDashboard"));
const Subscriptions = lazy(() => import("./views/Subscriptions"));
const NotificationDashboard = lazy(() => import("./views/NotificationDashboard"));
const EditCompanyPageAdmin = lazy(() => import("./components/EditCompanyPageAdmin"));
const StartupMarketing = lazy(() => import("./components/Brands/learn-more/StartupMarketing"));
const ContentMarketing = lazy(() => import("./components/Brands/learn-more/ContentMarketing"));
const AdminNotifications = lazy(() => import("./views/admin/components/NotificationsAdmin"));
const BrandSignUp = lazy(() => import("./views/auth/BrandSignUp"));
const StartupPackage = lazy(() => import("./views/brands/StartupPackage"));
const UserDashboardNotes = lazy(() => import("./components/StickyNotes/UserDashboardNotes"));

import Loading from "./components/Loading";

const Routes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/reader" />} />

        <Route exact path="/new" component={NewDraft} />
        <Route exact path="/slogging/:id" component={SloggingReordering} />
        <Route exact path="/sponsor" component={SponsorOnboarding} />
        <Route exact path="/sponsor/ad" component={SponsorAd} />
        <Route path="/login*" component={Login} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/unsubscribe" component={Unsubscribe} />

        <Route exact path="/brandlogin" component={BrandLogin} />
        <Route exact path="/brandsignup" component={BrandSignUp} />
        <BrandRoute exact path="/brand" component={Baa} />
        <BrandRoute exact path="/brand/startup-marketing" component={StartupMarketing} />
        <BrandRoute exact path="/brand/content-marketing" component={ContentMarketing} />
        <BrandRoute exact path="/brand/baa" component={Baa} />
        <BrandRoute exact path="/brand/startup-package" component={StartupPackage} />
        <BrandRoute exact path="/brand/ice-breaker" component={IceBreakerQuiz} />
        <Route exact path="/brands/ice-breaker" render={() => <Redirect to="/brand/ice-breaker" />} />
        <Route exact path="/dashboard/comments" render={() => <Redirect to="/writer/comments" />} />

        <AuthedRoute exact path="/drafts/:id" component={Editor} />
        <AuthedRoute exact path="/mobile/:id" component={Editor} />
        <AuthedRoute exact path="/activities/:draftId" component={DraftActivity} />
        <AuthedRoute path="/company" component={EditCompanyPageAdmin} />
        <AuthedRoute path="/writer" component={Home} />
        <AuthedRoute exact path="/sponsor/dashboard" component={SponsorDashboard} />
        <AuthedRoute exact path="/my-votes" component={MyVotes} />
        <AuthedRoute exact path="/stats" component={Stats} />
        <AuthedRoute exact path="/newsletter-stats" component={NewsletterStats} />
        <AuthedRoute exact path="/stats/:id" component={StoryStats} />
        <AuthedRoute path="/profile" component={Profile} />
        <AuthedRoute path="/boot" component={UserOnboarding} />
        <AuthedRoute exact path="/bookmarks" component={Bookmarks} />
        <AuthedRoute path="/subscriptions" component={Subscriptions} />
        <AuthedRoute exact path="/reader" component={ReaderDashboard} />
        <AuthedRoute exact path="/notifications" component={NotificationDashboard} />
        <AuthedRoute exact path="/about" component={About} />
        <AuthedRoute exact path="/my-notes" component={MyNotesDashboard} />
        <AuthedRoute exact path="/sticky-notes" component={UserDashboardNotes} />
        <EditorRoute exact path="/translated-story/:id" component={TranslatedEditor} />
        <EditorRoute exact path="/editor" component={EditorDashboard} />
        <EditorRoute exact path="/editor2" component={NewEditor} />

        <EditorRoute path="/admin/notifications" component={AdminNotifications} />
        <EditorRoute path="/admin" component={Admin} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
